( function ( $ ) {
    if ($('.social-share-pin').is(':visible')) {
        gsap.registerPlugin(ScrollTrigger);
        ScrollTrigger.matchMedia({
            "(min-width: 800px)": function() {
                ScrollTrigger.create({
                    start: "top top", // Top of pin is at top of viewport
                    pin: ".social-share-pin", // Pin this element between markers
                    endTrigger: ".ebayads-related-posts-wrap", // Footer
                    end: "bottom center", // When bottom of endTrigger is bottom of viewport
                    pinSpacing: false, // Padding is automatically added 
                    markers: false, // Onscreen markers for trigger areas
                    scrub: 1,
                    toggleClass: 'active', // used for css accounting for sticky header on scroll up
                });
            },
            "(max-width: 799px)": function() {
                killAll() ;
            },
        });
    }
} )( jQuery );
